import { Injectable } from "@angular/core";

@Injectable()
export class DisclaimerService {
    /**
     * Sets the disclaimer consent
     * @param name
     */
    public setConsentForBusinessFunction(defaultRoute: string): void {
        if (defaultRoute !== undefined) {
            localStorage.setItem(defaultRoute + "_disclaimer_consent", "true");
        }
    }

    /**
     * Gets the disclaimer consent
     * @param name
     */
    public getConsentForBusinessFunction(defaultRoute: string): boolean {
        if (localStorage.getItem(defaultRoute + "_disclaimer_consent") == null) {
            return false;
        }
        return localStorage.getItem(defaultRoute + "_disclaimer_consent") === "true";
    }
}